import React from "react";
import AppRoutes from "./Routes";
import "react-image-crop/dist/ReactCrop.css";

function App() {
  return <AppRoutes />;
}

export default App;
